<template>
  <div v-if="state.isShow" class="loading-container">
  <van-loading  type="spinner" color="#1989fa" />
  </div>
  <div v-else id="box">
    <header>
      <MobileMenu @clickMenu="clickMenu" :bgc="state.bgc"/>
     </header>
     <main>
          <slot />
      </main>
      <footer>
        <MobileFooter/>
      </footer>
  </div>
</template>
<script setup>
import { reactive,onMounted, onUnmounted ,watch } from 'vue'
const router = useRouter()
const route = useRoute()
const state=reactive({
  bgc:'',
  scrollTop:0,
  isShow:true,
})
const clickMenu = (item,index) => {
 navigateTo(item?.children[index]?.path)
}

watch(()=>router,(val)=>{
  if(val.currentRoute.value.name?.length===1){
    state.bgc=''
  }else{
    state.bgc='#fff'
    if(state.scrollTop===0){
      state.bgc='#fff'
    }
  }
},{immediate:true,deep:true})

function handleScroll() {
    state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(state.scrollTop>50){
        state.bgc='#fff'
      } else {
        state.bgc=''
      }
  }
onMounted(()=>{
  window.addEventListener('scroll',handleScroll);
  if(route.name.includes('index')||route.name.includes('m')){
    state.isShow=false
  } else {
    state.isShow = true
  }
  // router.beforeEach((to,from)=>{
  //   console.log(to.name,'to');
  //   console.log(from.name,'from');
  // })
})
onUnmounted(()=>{
  window.removeEventListener('scroll',handleScroll)
})
</script>
<style>
.loading-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>